import React, {useEffect, useState} from 'react';
import Select from "react-select";
import {forEach} from "lodash";
import {Typography} from "@material-tailwind/react";
import {BsDatabase, BsSearch} from "react-icons/bs";


const SelectInput = ({
                       className,
                       defaultValue,
                       options,
                       autoLoadService,
                       autoLoadServiceData,
                       autoLoadRender,
                       onChange,
                       label,
                       refreshSignal,
                       multiselect,
                       title,
                       setTitle,
                       description,
                       setDescription,
                       name,
                       setName,
                       family,
                       setFamily,
                       phone,
                       setPhone,
                       selectStyles,
                       hideLabel,
                       placeholder,
                       placeholderIcon: PlaceholderIcon = BsSearch,
                       stackedLabel = false,
                       disabled = false,
                     }) => {
  const [selectedOption, setSelectedOption] = useState(multiselect ? [] : "");
  const [optionList, setOptionList] = useState([]);
  const menuPortalTarget = typeof document !== "undefined" ? document.body : undefined;

  const decorateSelectDate = function (lst) {
    const res = [];
    forEach(lst, item => {
      const new_item = {
        value: item.id,
        label: autoLoadRender ? autoLoadRender(item) : item.title
      }
      if (title) {
        new_item.title = item.title;
      }
      if (description) {
        new_item.description = item.description;
      }
      if (name) {
        new_item.name = item.name;
      }
      if (family) {
        new_item.family = item.family;
      }
      if (phone) {
        new_item.phone = item.phone;
      }
      res.push(new_item)
    })
    return res;
  };

  useEffect(() => {
    if (defaultValue) {
      console.log("defaultValue: ", defaultValue)
      if (multiselect) {
        setSelectedOption([]);
        const opts = defaultValue
          .map(value => optionList.find(option => option.value === value))
          .filter(option => option !== undefined);

        setSelectedOption(opts);
      } else {
        const defaultOption = optionList.find(option => option.value === defaultValue);
        if (defaultOption) {
          setSelectedOption(defaultOption);
        } else {
          setSelectedOption(null);
        }
      }
    }
  }, [optionList, defaultValue]);

  useEffect(() => {
    if (title) {
      setTitle(selectedOption ? selectedOption.title : "");
    }
    if (description) {
      setDescription(selectedOption ? selectedOption.description : "");
    }
    if (name) {
      setName(selectedOption ? selectedOption.name : "");
    }
    if (family) {
      setFamily(selectedOption ? selectedOption.family : "");
    }
    if (phone) {
      setPhone(selectedOption ? selectedOption.phone : "");
    }
  }, [selectedOption]);

  async function getData() {
    const result = await autoLoadService(autoLoadServiceData);
    if (result.status === 200) {
      const res = result.data;
      if (Object.values(res) &&
        Object.values(res)[0] &&
        Array.isArray(Object.values(res)[0])) {
        const result = decorateSelectDate(Object.values(res)[0]);
        setOptionList(result);
      }
    }
  }

  useEffect(() => {
    if (!refreshSignal) {
      setSelectedOption(null)
    }

    if (options) {
      const result = decorateSelectDate(options);
      setOptionList(result)
    }

    if (autoLoadService) {
      getData();
    }
  }, [refreshSignal || null]);

  return (
    <div className={`flex w-full ${stackedLabel ? "flex-col gap-2" : "flex-row justify-between"}`}>
      {!hideLabel && (
        <Typography
          className={stackedLabel
            ? "px-1 text-sm font-medium text-app-text-muted"
            : "pl-2 my-auto text-gray-500 font-thin w-1/4"}
          variant="small"
        >
          {label}{stackedLabel ? "" : ":"}
        </Typography>
      )}
      <div className="w-full">
        <Select
          aria-label={label || placeholder || "انتخاب گزینه"}
          value={selectedOption}
          onChange={(option) => {
            setSelectedOption(option);
            if (multiselect) {
              onChange(option.map(o => o.value));
            } else {
              onChange(option.value);
            }
          }}
          options={optionList}
          noOptionsMessage={() => {
            return <Typography className="text-sm flex flex-row justify-center gap-x-2">
              <BsDatabase className="text-lg"/>
              بدون اطلاعات
            </Typography>
          }}
          isSearchable={true}
          isMulti={multiselect}
          isDisabled={disabled}
          menuPortalTarget={menuPortalTarget}
          menuPosition="fixed"
          placeholder={
            <Typography className="text-sm flex flex-row gap-x-2">
              {PlaceholderIcon && <PlaceholderIcon className="text-md"/>}
              {placeholder || "جست‌و‌جو..."}
            </Typography>
          }
          className={`${className}`}
          styles={{
            menu: (provided) => ({
              ...provided,
              backgroundColor: 'rgb(var(--color-app-raised))',
              border: '1px solid rgb(var(--color-app-border))',
              zIndex: 9999,
              overflow: 'hidden',
              borderRadius: 10,
              boxShadow: 'var(--app-shadow-strong)',
            }),
            menuPortal: (provided) => ({
              ...provided,
              zIndex: 99999,
            }),
            option: (provided, state) => ({
              ...provided,
              backgroundColor: state.isSelected
                ? 'rgb(var(--color-app-primary-soft))'
                : state.isFocused
                  ? 'rgb(var(--color-app-muted))'
                  : 'rgb(var(--color-app-raised))',
              color: 'rgb(var(--color-app-text))',
              cursor: 'pointer',
            }),
            control: (provided, state) => ({
              ...provided,
              backgroundColor: 'rgb(var(--color-app-surface))',
              minHeight: stackedLabel ? 48 : provided.minHeight,
              borderRadius: stackedLabel ? 12 : provided.borderRadius,
              borderColor: state.isFocused
                ? 'rgb(var(--color-app-focus))'
                : 'rgb(var(--color-app-border))',
              boxShadow: state.isFocused
                ? '0 0 0 3px rgb(var(--color-app-focus) / 0.14)'
                : 'none',
            }),
            singleValue: (provided) => ({
              ...provided,
              color: 'rgb(var(--color-app-text))',
            }),
            input: (provided) => ({
              ...provided,
              color: 'rgb(var(--color-app-text))',
            }),
            placeholder: (provided) => ({
              ...provided,
              color: 'rgb(var(--color-app-text-subtle))',
            }),
            multiValue: (provided) => ({
              ...provided,
              backgroundColor: 'rgb(var(--color-app-primary-soft))',
            }),
            multiValueLabel: (provided) => ({
              ...provided,
              color: 'rgb(var(--color-app-text))',
            }),
            ...selectStyles,
          }}
        />
      </div>

    </div>
  );
};

export default SelectInput;
